import { createFileRoute } from "@tanstack/react-router"
import { ContentDocumentsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/content/documents"
)({
  component: () => (
    <AuthorizationGate resource={Resource.CONTENT} action={Action.READ}>
      <ContentDocumentsPage />
    </AuthorizationGate>
  ),
})
